import { render, staticRenderFns } from "./SingleTicket.vue?vue&type=template&id=55e23ed3&scoped=true&"
import script from "./SingleTicket.vue?vue&type=script&lang=js&"
export * from "./SingleTicket.vue?vue&type=script&lang=js&"
import style1 from "./SingleTicket.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55e23ed3",
  null
  
)

export default component.exports